export default "__VITE_ASSET__REefr9pk3kJnJq37KoV4YA__"